import { render } from "./EditPerformanceTracker.vue?vue&type=template&id=c553b710"
import script from "./EditPerformanceTracker.vue?vue&type=script&lang=js"
export * from "./EditPerformanceTracker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__